export default __webpack_public_path__ + "static/media/date-icon.37ac5cef.svg";